module.exports = __webpack_public_path__ + "static/img/icon-user-guide.e4b06fa8.png";